module.exports = __webpack_public_path__ + "static/img/Moyo.1b8179a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Moyo.png
// module id = wEKo
// module chunks = 0